// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import { between } from '../_common/api/utility';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';

const ColorCard = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${({ color }) => color};
    border-radius: 1rem 1rem 0 0;
    padding: 1em;
    height: 100%;
    color:  ${({ theme }) => theme.mobile.contrast};
    font-weight: 800;
`
const ImgCard = styled.div`
    background-image: url(${({ image }) => `https://ewash.net/HamiltonCarWash/static/media/slideLogo${image}@2x.png`});
    background-repeat: no-repeat;
    background-size: cover;

    background-size: 120%;
    
    /*background-attachment: fixed;*/

    border-radius: 1rem 1rem 0rem 0rem;
`

const ImageCard = ({ parentId, item, children, ...props }) => {
    const { state: {
        site_config,
    } } = useGlobalState();

    const content = document.querySelector('#ItemWrapper') || document.querySelector('#content_wrapper');
    const [pos, setPos] = useState(0)

    const updatePosition = () => {
        const element = document.querySelector('#' + parentId);
        const pos = element.getBoundingClientRect()
        const newPos = ((pos.left + (pos.width / 2)) / window.screen.width) * 100
        setPos(newPos)
    }

    useLayoutEffect(() => {
        if (site_config.imgParallax) updatePosition()
    }, [])

    useEffect(() => {
        if (site_config.imgParallax) {
            content.addEventListener('scroll', updatePosition);
            return () => content.removeEventListener('scroll', updatePosition);
        }
    })

    return (
        <ImgCard image={item.logo.imageIndex} parallax={pos} style={site_config.imgParallax ? { backgroundPosition: `${between(pos, 0, 100)}% center` } : null} {...props}>
            <ColorCard color={`rgb(${item.logo.red}, ${item.logo.green}, ${item.logo.blue}, ${item.logo.alpha})`}>
                {children}
            </ColorCard>
        </ImgCard>
    );
}

export default ImageCard;